import BaseStore from '@/store/base-store'

const options = {}
export default new BaseStore('tractors', options)



// WEBPACK FOOTER //
// ./src/store/modules/tractors.store.js